import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import Main from './Main';
import HeroResearch from './HeroResearch';
import ResearchInfo from './ResearchInfo';
import ImageSection from '../../components/ImageSection/ImageSection';

const Research = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <HeroResearch />
            <ResearchInfo />
            <ImageSection />
            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default Research;
